import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { FinancialInstitutionsType } from '../../api/awsApis'

type State = {
  filterType: 'Country' | 'Financial Institution'
  searchValue: string
  currentPage: number
  currentData: FinancialInstitutionsType[]
  loading: boolean
  error?: string | undefined
}

// Default initial state
const initialState: State = {
  filterType: 'Country',
  searchValue: '',
  currentPage: 1,
  currentData: [],
  loading: false,
  error: undefined,
}

const fiSlice = createSlice({
  name: 'fi_slice',
  initialState: initialState,
  reducers: {
    setError: (state: State, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setFilterType: (
      state: State,
      action: PayloadAction<'Country' | 'Financial Institution'>,
    ) => {
      state.filterType = action.payload
    },
    setSearchValue: (state: State, action: PayloadAction<string>) => {
      state.searchValue = action.payload
    },
    setCurrentPage: (state: State, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setCurrentData: (
      state: State,
      action: PayloadAction<FinancialInstitutionsType[]>,
    ) => {
      state.currentData = action.payload
    },
    setLoading: (state: State, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    resetState: () => initialState,
  },
})

export const selectState = (state: RootState) => state.fi_slice
export const {
  setError,
  setFilterType,
  setSearchValue,
  setCurrentPage,
  setCurrentData,
  setLoading,
  resetState,
} = fiSlice.actions
export default fiSlice.reducer
